module.exports = __webpack_public_path__ + "img/未标题-12.f9e08e52.png";